export default {
  data() {
    return {
      selectedCurrency: "EUR",
      currencies: [
        { code: "USD", symbol: "$" },
        { code: "EUR", symbol: "€" },
        { code: "GBP", symbol: "£" },
        { code: "AUD", symbol: "A$" }
      ]
    };
  },
  mounted() {
    this.resumeCurrency();
  },
  computed: {
    currency() {
      const currency = this.displayOptions?.currency
        ? this.displayOptions.currency
        : "EUR";
      const symbol = this.currencySymbol(currency);
      return {
        code: currency,
        symbol: symbol
      };
    },
    selectedCurrencyWithCode() {
      return this.currencyByCode(this.selectedCurrency);
    }
  },
  methods: {
    resumeCurrency() {
      this.selectedCurrency =
        window.KTCookie.getCookie("_HAPI_CURRENCY_OVERRIDE") || "EUR";
    },
    currencySymbol(currencyCode) {
      const currency = this.currencies.find(
        i => i.code.toUpperCase() === currencyCode.toUpperCase() && i.symbol
      );
      if (!currency) {
        return currencyCode;
      }
      return currency.symbol;
    },
    currencyByCode(currencyCode) {
      const defaultCurrency = { code: "n/a", symbol: "n/a" };
      const currency = this.currencies.find(
        i => i.code.toUpperCase() === currencyCode.toUpperCase()
      );
      if (!currency) {
        return defaultCurrency;
      }
      return currency;
    },
    changeCurrency(currency) {
      this.selectedCurrency = currency;
      if (currency) {
        // update cookie
        window.KTCookie.setCookie("_HAPI_CURRENCY_OVERRIDE", currency, 365);
        // reload page
        window.location.reload();
      }
    },
    updateDisplayOptions() {
      this.$emit("update-display-options", {
        ...this.displayOptions,
        currency: this.selectedCurrency
      });
    }
  }
};
